// PATH: src/components/catalog/missionZero.ts
/** Mission Zéro : contrôle du JSON collé (pur, testé). */

/** Vérifie le JSON collé ; renvoie la charge à envoyer ou un message d'erreur. */
export const parseMissionZeroJson = (text: string): { payload: unknown; count: number } | { error: string } => {
  let raw: unknown;
  try {
    raw = JSON.parse(text);
  } catch {
    return { error: "JSON invalide." };
  }
  let items: unknown;
  if (Array.isArray(raw)) items = raw;
  else if (raw && typeof raw === "object" && "age_range" in raw) items = (raw as { items?: unknown }).items;
  else return { error: "Format non reconnu : un tableau d'items, ou un objet { age_range, items, scoring_notes }." };
  if (!Array.isArray(items) || items.length === 0) return { error: "Aucun item." };
  const bad = items.findIndex((it) => !it?.item_id || !it?.block || !it?.render_type);
  if (bad >= 0) return { error: `Item n° ${bad + 1} : item_id, block et render_type sont requis.` };
  return { payload: raw, count: items.length };
};
